var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "盘库单 - " + _vm.info.checkNo,
        "before-close": _vm.close,
        fullscreen: "",
        "custom-class": "inventory-detail-dialog",
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "p16" },
        [
          _c(
            "el-form",
            {
              ref: "detailQueryFormRef",
              attrs: { model: _vm.queryParams, inline: "" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.queryParams.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "name", $$v)
                      },
                      expression: "queryParams.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品条码", prop: "barcode" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.queryParams.barcode,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "barcode", $$v)
                      },
                      expression: "queryParams.barcode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onQuery } },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "detailTableRef",
              attrs: {
                data: _vm.list,
                height: "calc(100vh - 246px)",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "明细ID",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "brand", label: "商品品牌", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "goodsName", label: "商品名称", width: "350" },
              }),
              _c("el-table-column", {
                attrs: { prop: "spec", label: "商品规格", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "barcode", label: "商品条码", width: "130" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "actualQty",
                  label: "实际库存",
                  width: "100",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "systemQty",
                  label: "系统库存",
                  width: "100",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "diffQty",
                  label: "差异数量",
                  width: "100",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注", "min-width": "300" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  align: "center",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.parseTime(scope.row.createTime)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: "更新时间",
                  align: "center",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.parseTime(scope.row.updateTime)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.info.status === 0
                ? _c("el-table-column", {
                    attrs: { fixed: "right", label: "操作", width: "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: ["admin:stockCheck:update"],
                                      expression: "['admin:stockCheck:update']",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onUpdate(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("更新")]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: ["admin:stockCheck:delete"],
                                      expression: "['admin:stockCheck:delete']",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDelete(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1052014460
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticClass: "mt16 mb16",
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80, 100],
                  "page-size": _vm.queryParams.limit,
                  "current-page": _vm.queryParams.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onPageChange,
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mt20", attrs: { type: "flex", justify: "end" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.close } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CheckEditor", {
        ref: "checkEditorRef",
        on: { success: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }